import { useState } from 'react';
import { Box, Button, Typography, Grid, Backdrop, CircularProgress, ThemeProvider } from '@mui/material';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { BASEURL, ARROW } from '../../constants/Common';
import getTheme from '../../theme/theme';
import FloatingButton from '../usersupport/helpdesk/FloatingButton';



function FreeTrialPage(): JSX.Element {
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { subscriptionData, orgfinData } = location.state;


  const storedData = localStorage.getItem('orgid');
  let parsedData: any = null;

  if (storedData) {
    parsedData = JSON.parse(storedData);
  } else {
    navigate('/login');
  }

  const subid = parsedData;

  // Calculate the start and end dates
  const startDate = new Date().toISOString().slice(0, 10);
  const endDate = new Date(Date.now() + 15 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10);

  const handleStartTrial = async () => {
    const payload = {
      organization_id: subid,
      organization_name: orgfinData?.organization?.organization_name,
      organization_subscription_status: 'Active',
      subscription_start_date: startDate,
      subscription_end_date: endDate,
      active_users_count: orgfinData?.organization?.active_users_count,
      active_project_count: orgfinData?.organization?.active_project_count,
      subscription_id: '7',
      user_id: orgfinData?.organization?.user_id,
      has_used_freetrial: 'True',
    };
    console.log(payload)

    try {
      setLoading(true);
      const response = await axios.put(
        `${BASEURL}/organizations/update/${subid}/`,
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      // console.log('Subscription plan updated successfully:', response.data);
      navigate('/subscriptions');
    } catch (error) {
      console.error('Error updating subscription plan:', error);
    } finally {
      setLoading(false);
    }
  };


  return (
    <ThemeProvider theme={getTheme()}>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color='inherit' />
      </Backdrop>
      <Box
        sx={{
          pt: 5,
          pb: 10,
          px: 2,
          mt: '-80px',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'left', marginTop: 0 }}>
          <Typography variant="h6" gutterBottom>
            <Link to={'/subscriptions'}>Subscriptions</Link>
            {ARROW}
            Free trial
          </Typography>
        </Box>

        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography variant="subtitle1">Selected Plan:</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle1">{subscriptionData.title}</Typography>
          </Grid>
          <Grid item xs={6} sx={{ mt: '10px' }}>
            <Typography variant="subtitle1">Plan Start Date:</Typography>
          </Grid>
          <Grid item xs={6} sx={{ mt: '10px' }}>
            <Typography variant="subtitle1">{startDate}</Typography>
          </Grid>
          <Grid item xs={6} sx={{ mt: '10px' }}>
            <Typography variant="subtitle1">Plan End Date:</Typography>
          </Grid>
          <Grid item xs={6} sx={{ mt: '10px' }}>
            <Typography variant="subtitle1">{endDate}</Typography>
          </Grid>
          <Grid item xs={6} sx={{ mt: '10px' }}>
            <Typography variant="subtitle1">Cost of Plan:</Typography>
          </Grid>
          <Grid item xs={6} sx={{ mt: '10px' }}>
            <Typography variant="subtitle1">USD 0</Typography>
          </Grid>
        </Grid>

        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button variant="contained" color="primary" onClick={handleStartTrial}>
            Start Free Trial
          </Button>
        </Box>
      </Box>
      <FloatingButton />
    </ThemeProvider>
  );
};

export default FreeTrialPage;
